import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { WebCamComponent } from 'ack-angular-webcam';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { AutocompleteModule } from 'ng2-input-autocomplete';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
import {Debounce} from 'angular2-debounce';
import { ImageUploadModule } from "angular2-image-upload";
import {CarouselModule} from "angular2-carousel";


import { TechnicalServiceGuard } from './guards/technicalService.guard';

import { MergePipe } from './pipes/merge.pipe';


import { AppComponent } from './app.component';
import { AuthComponent } from './auth/components/auth.component';
import { HomeComponent } from './home/home.component';

import { PurchaseComponent } from './purchase/components/purchase.component';

import { ProductComponent } from './products/components/product/product.component';
import { ViewProductComponent } from './products/components/view-product/view-product.component';
import { ListProductComponent } from './products/components/list-product/list-product.component';

import { PersonComponent } from './person/components/person/person.component';
import { ViewPersonComponent } from './person/components/view-person/view-person.component';


import { RepurchaseRouter } from './repurchase/repurchase.router';
import { RepurchaseComponent } from './repurchase/repurchase.component';
import { ViewRepurchaseComponent } from './repurchase/components/view-repurchase/view-repurchase.component';
import { HomeRepurchaseComponent } from './repurchase/components/home-repurchase/home-repurchase.component';
import { ListRepurchaseComponent } from './repurchase/components/list-repurchase/list-repurchase.component';
import { ListRepurchaseRenewalComponent } from './repurchase/components/list-repurchase-renewal/list-repurchase-renewal.component';


import { TechnicalserviceRouter } from './technicalservice/technicalservice.router';
import { TechnicalserviceComponent } from './technicalservice/technicalservice.component';
import { ViewTechnicalserviceComponent } from './technicalservice/components/view-technicalservice/view-technicalservice.component';
import { HomeTechnicalserviceComponent } from './technicalservice/components/home-technicalservice/home-technicalservice.component';
import { ListTechnicalserviceComponent } from './technicalservice/components/list-technicalservice/list-technicalservice.component';
import { ViewTechnicalserviceRepairComponent } from './technicalservice/components/view-technicalservice-repair/view-technicalservice-repair.component';


import { ListTechnicalserviceCompaniesComponent } from './configuration/components/technicalservice-companies/list-technicalservice-companies/list-technicalservice-companies.component';
import { ViewTechnicalserviceCompaniesComponent } from './configuration/components/technicalservice-companies/view-technicalservice-companies/view-technicalservice-companies.component';


import { ConsignmentserviceRouter } from './consignment/consignment.router';
import { ConsignmentComponent } from './consignment/consignment.component';
import { HomeConsignmentComponent } from './consignment/components/home-consignment/home-consignment.component';
import { ViewConsignmentComponent } from './consignment/components/view-consignment/view-consignment.component';
import { ListConsignmentComponent } from './consignment/components/list-consignment/list-consignment.component';
import { ListConsignmentStatesComponent } from './consignment/components/list-consignment-states/list-consignment-states.component';
import { ListConsignmentPaymentsComponent } from './consignment/components/list-consignment-payments/list-consignment-payments.component';
import { ListConsignmentReturnsComponent } from './consignment/components/list-consignment-returns/list-consignment-returns.component';

import { ReportsRouter } from './reports/reports.router';
import { ReportsComponent } from './reports/reports.component';
import { HomeReportsComponent } from './reports/components/home-reports/home-reports.component';
import { ListPeopleComponent } from './reports/components/list-people/list-people.component';
import { ListPurchasesComponent } from './reports/components/list-purchases/list-purchases.component';
import { PoliceReportComponent } from './reports/components/police-report/police-report.component';
import { StatsComponent } from './reports/components/stats/stats.component';
import { ListInvoicesComponent } from './reports/components/list-invoices/list-invoices.component';

import { ConfigurationRouter } from './configuration/configuration.router';
import { ConfigurationComponent } from './configuration/configuration.component';
import { HomeConfigurationComponent } from './configuration/components/home-configuration/home-configuration.component';

import { ListProductBrandsComponent } from './configuration/components/product-brands/list-product-brands/list-product-brands.component';
import { ViewProductBrandsComponent } from './configuration/components/product-brands/view-product-brands/view-product-brands.component';

import { ViewProductTelephoneCompaniesComponent } from './configuration/components/product-telephone-companies/view-product-telephone-companies/view-product-telephone-companies.component';
import { ListProductTelephoneCompaniesComponent } from './configuration/components/product-telephone-companies/list-product-telephone-companies/list-product-telephone-companies.component';

import { ListProductStatusesComponent } from './configuration/components/product-statuses/list-product-statuses/list-product-statuses.component';
import { ViewProductStatusesComponent } from './configuration/components/product-statuses/view-product-statuses/view-product-statuses.component';

import { ListProductModelsComponent } from './configuration/components/product-models/list-product-models/list-product-models.component';
import { ViewProductModelsComponent } from './configuration/components/product-models/view-product-models/view-product-models.component';

import { ListProductOperatingSystemsComponent } from './configuration/components/product-operating-systems/list-product-operating-systems/list-product-operating-systems.component';
import { ViewProductOperatingSystemsComponent } from './configuration/components/product-operating-systems/view-product-operating-systems/view-product-operating-systems.component';

import { ViewProductStorageCapacitiesComponent } from './configuration/components/product-storage-capacities/view-product-storage-capacities/view-product-storage-capacities.component';
import { ListProductStorageCapacitiesComponent } from './configuration/components/product-storage-capacities/list-product-storage-capacities/list-product-storage-capacities.component';

import { ViewProductRamsComponent } from './configuration/components/product-rams/view-product-rams/view-product-rams.component';
import { ListProductRamsComponent } from './configuration/components/product-rams/list-product-rams/list-product-rams.component';

import { ListShopsComponent } from './configuration/components/shops/list-shops/list-shops.component';
import { ViewShopsComponent } from './configuration/components/shops/view-shops/view-shops.component';

import { ListProductCpusComponent } from './configuration/components/product-cpus/list-product-cpus/list-product-cpus.component';
import { ViewProductCpusComponent } from './configuration/components/product-cpus/view-product-cpus/view-product-cpus.component';

import { UserComponent } from './user/user.component';
import { ListUserComponent } from './user/components/list-user/list-user.component';
import { ViewUserComponent } from './user/components/view-user/view-user.component';
import { UserRouter } from './user/user.router';
import { HomeUserComponent } from './user/components/home-user/home-user.component';

import { HeaderComponent } from './common/components/header/header.component';

import { ViewLabeledProductComponent } from './labeledproducts/components/view-labeledproduct/view-labeledproduct.component';
import { ListLabeledProductComponent } from './labeledproducts/components/list-labeledproduct/list-labeledproduct.component';
import { ListLabeledProductReportComponent } from './labeledproducts/components/list-labeledproduct-report/list-labeledproduct-report.component';
import { ListLabeledProductMinStockComponent } from './labeledproducts/components/list-labeledproduct-min-stock/list-labeledproduct-min-stock.component';
import { ViewLabeledProductEditStockComponent } from './labeledproducts/components/view-labeledproduct-edit-stock/view-labeledproduct-edit-stock.component';
import { ListSaleLabeledProductDistributorComponent } from './labeledproducts/components/list-salelabeledproductdistributor/list-salelabeledproductdistributor.component';

import { TPVComponent } from './tpv/components/tpv/tpv.component';
import { TPVReturnComponent } from './tpv/components/tpv-return/tpv-return.component';
import { ListSaleComponent } from './sales/components/list-sale/list-sale.component';
import { ListSaleReturnComponent } from './salesreturn/components/list-sale-return/list-sale-return.component';
import { TpvSummaryComponent } from './tpv/components/tpv-summary-report/tpv-summary-report.component';

import { HomeLabeledProductComponent } from './labeledproducts/components/home-labeledproduct/home-labeledproduct.component';

import { ViewDistributorComponent } from './distributors/components/view-distributor/view-distributor.component';
import { ListDistributorComponent } from './distributors/components/list-distributor/list-distributor.component';

import { ExpensesRouter } from './expenses/expenses.router';
import { ExpensesComponent } from './expenses/expenses.component';
import { ViewExpensesComponent } from './expenses/components/view-expenses/view-expenses.component';
import { ListExpensesComponent } from './expenses/components/list-expenses/list-expenses.component';

import { ViewExpectedExpensesComponent } from './expenses/components/view-expected-expenses/view-expected-expenses.component';
import { ListExpectedExpensesComponent } from './expenses/components/list-expected-expenses/list-expected-expenses.component';

import { ListReservationComponent } from './reservation/components/list-reservation/list-reservation.component';
import { ViewReservationComponent } from './reservation/components/view-reservation/view-reservation.component';

import { CashMovementRouter } from './cashmovements/cash-movement.router';
import { CashMovementComponent } from './cashmovements/cash-movement.component';
import { ViewCashMovementComponent } from './cashmovements/components/view-cash-movement/view-cash-movement.component';
import { ListCashMovementComponent } from './cashmovements/components/list-cash-movement/list-cash-movement.component';

import { ListTicketsComponent } from './sales/components/list-tickets/list-tickets.component';



import { InventoryRouter } from './inventory/inventory.router';
import { InventoryComponent } from './inventory/inventory.component';
import { HomeInventoryComponent } from './inventory/components/home-inventory/home-inventory.component';
import { WizardInventoryComponent } from './inventory/components/wizard-inventory/wizard-inventory.component';
import { ReportInventoryComponent } from './inventory/components/report-inventory/report-inventory.component';


import { TransferRouter } from './transfer/transfer.router';
import { TransferComponent } from './transfer/transfer.component';
import { HomeTransferComponent } from './transfer/components/home-transfer/home-transfer.component';
import { ListTransferComponent } from './transfer/components/list-transfer/list-transfer.component';
import { ViewTransferComponent } from './transfer/components/view-transfer/view-transfer.component';


const appRoutes: Routes = [
   { path: 'login', component: AuthComponent },
   { path: 'person/:id', component: ViewPersonComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'product/list', component: ListProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'product/listtolabel', component: ListProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'product/:id', component: ViewProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'purchase', component: PurchaseComponent, canActivate: [TechnicalServiceGuard]},
   { path: 'purchase/:id', component: PurchaseComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'repurchase', component: RepurchaseComponent, children: RepurchaseRouter, canActivate: [TechnicalServiceGuard]},
   { path: 'consignment', component: ConsignmentComponent, children: ConsignmentserviceRouter, canActivate: [TechnicalServiceGuard]},
   { path: 'technicalservice', component: TechnicalserviceComponent, children: TechnicalserviceRouter },
   { path: 'configuration', component: ConfigurationComponent, children: ConfigurationRouter, canActivate: [TechnicalServiceGuard] },
   { path: 'reports', component: ReportsComponent, children: ReportsRouter, canActivate: [TechnicalServiceGuard] },
   { path: 'user', component: UserComponent, children: UserRouter, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproducthome', component: HomeLabeledProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproduct/list', component: ListLabeledProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproductreport/list', component: ListLabeledProductReportComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproduct/listtoeditstock', component: ListLabeledProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproduct', component: ViewLabeledProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproduct/view/:id', component: ViewLabeledProductComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproductminstock/list', component: ListLabeledProductMinStockComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'saleLabeledProductDistributor/list', component: ListSaleLabeledProductDistributorComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'labeledproduct/editStock/:id', component: ViewLabeledProductEditStockComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tpv', component: TPVComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tpvOnline', component: TPVComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tpv/:id', component: TPVComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tpvreturn', component: TPVReturnComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tpvreturn/:id', component: TPVReturnComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'turnsummaryreport', component: TpvSummaryComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'sales', component: ListSaleComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'tickets', component: ListTicketsComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'salesreturn', component: ListSaleReturnComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'distributor/list', component: ListDistributorComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'distributor/:id', component: ViewDistributorComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'distributor', component: ViewDistributorComponent, canActivate: [TechnicalServiceGuard] },
   { path: 'expenses', component: ExpensesComponent, children: ExpensesRouter, canActivate: [TechnicalServiceGuard]},
   { path: 'cashmovement', component: CashMovementComponent, children: CashMovementRouter, canActivate: [TechnicalServiceGuard]},
   { path: 'reservation/list', component: ListReservationComponent, canActivate: [TechnicalServiceGuard]},
   { path: 'reservation/view/:id', component: ViewReservationComponent, canActivate: [TechnicalServiceGuard]},
   { path: 'reservation/create', component: ViewReservationComponent, canActivate: [TechnicalServiceGuard]},
   { path: 'inventory', component: InventoryComponent, children: InventoryRouter },
   { path: 'transfer', component: TransferComponent, children: TransferRouter },
   { path: '', component: HomeComponent },
   { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    HomeComponent,
    PurchaseComponent,
    ProductComponent,
    ViewProductComponent,
    ListProductComponent,
    PersonComponent,
    ViewPersonComponent,
    RepurchaseComponent,
    ViewRepurchaseComponent,
    HomeRepurchaseComponent,
    ListRepurchaseComponent,
    ConsignmentComponent,
    TechnicalserviceComponent,
    ViewTechnicalserviceComponent,
    HomeTechnicalserviceComponent,
    HomeConsignmentComponent,
    ViewConsignmentComponent,
    ListConsignmentComponent,
    ListTechnicalserviceComponent,
    ReportsComponent,
    HomeReportsComponent,
    ListPeopleComponent,
    ListPurchasesComponent,
    ConfigurationComponent,
    HomeConfigurationComponent,
    ListProductBrandsComponent,
    ViewProductBrandsComponent,
    ViewProductTelephoneCompaniesComponent,
    ListProductTelephoneCompaniesComponent,
    ListProductStatusesComponent,
    ViewProductStatusesComponent,
    ListProductModelsComponent,
    ViewProductModelsComponent,
    ListProductOperatingSystemsComponent,
    ViewProductOperatingSystemsComponent,
    ViewProductStorageCapacitiesComponent,
    ListProductStorageCapacitiesComponent,
    ViewProductRamsComponent,
    ListProductRamsComponent,
    ListTechnicalserviceCompaniesComponent,
    ViewTechnicalserviceCompaniesComponent,
    WebCamComponent,
    ViewTechnicalserviceRepairComponent,
    HeaderComponent,
    PoliceReportComponent,
    ListProductCpusComponent,
    ViewProductCpusComponent,
    ListShopsComponent,
    ViewShopsComponent,
    Debounce,
    UserComponent,
    ListUserComponent,
    ViewUserComponent,
    HomeUserComponent,
    StatsComponent,
    ListLabeledProductComponent,
    ViewLabeledProductComponent,
    TPVComponent,
    ListSaleComponent,
    MergePipe,
    HomeLabeledProductComponent,
    ViewLabeledProductEditStockComponent,
    ListDistributorComponent,
    ViewDistributorComponent,
    TPVReturnComponent,
    ListSaleReturnComponent,
    ListLabeledProductReportComponent,
    ListLabeledProductMinStockComponent,
    ExpensesComponent,
    ViewExpensesComponent,
    ListExpensesComponent,
    ViewExpectedExpensesComponent,
    ListExpectedExpensesComponent,
    ViewReservationComponent,
    ListReservationComponent,
    CashMovementComponent,
    ViewCashMovementComponent,
    ListCashMovementComponent,
    ListSaleLabeledProductDistributorComponent,
    ListTicketsComponent,
    InventoryComponent,
    TransferComponent,
    HomeTransferComponent,
    ListTransferComponent,
    ViewTransferComponent,
    HomeInventoryComponent,
    WizardInventoryComponent,
    ReportInventoryComponent,
    ListRepurchaseRenewalComponent,
    ListInvoicesComponent,
    TpvSummaryComponent,
    ListConsignmentStatesComponent,
    ListConsignmentPaymentsComponent,
    ListConsignmentReturnsComponent
    ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    ToastModule.forRoot(),
    AutocompleteModule.forRoot(),
    NgxPaginationModule,
    ImageUploadModule.forRoot(),
    CarouselModule
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}, TechnicalServiceGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts